import { createApp } from 'vue';
import TtfToOtfConverter from '@/Components/TtfToOtfConverter.vue';
import '@styles/app.css';

createApp(TtfToOtfConverter).mount('#ttf-to-otf-converter');
